export enum NewsStatusEnum {
  CREATED = 'CREATED',
  PUBLISHED = 'PUBLISHED',
  EXPIRED = 'EXPIRED',
}
